<template>
  <div>
    <div class="report-link flex-between">
      <div class="report-link_block">
        <span v-if="mcReportElement.extraInformation.segment" class="report__bold-text">
          {{segmentIdToNameSegment(mcReportElement.extraInformation.segment)}}
        </span>
        <a
          v-if="mcReportElement.extraInformation.backofficeLink"
          :href="mcReportElement.extraInformation.backofficeLink"
          target="_blank">
          {{$t('mc.mimk.mcReport.linkText.backOffice')}}
          <inline-svg
            class="sidebar-select__arrow"
            :src="require(`@/assets/svg/pin.svg`)"
          />
        </a>
        <a
          v-if="mcReportElement.extraInformation.amoLink"
          :href="mcReportElement.extraInformation.amoLink"
          target="_blank">
          {{$t('mc.mimk.mcReport.linkText.amo')}}
          <inline-svg
            class="sidebar-select__arrow"
            :src="require(`@/assets/svg/pin.svg`)"
          />
        </a>
      </div>
      <span class="report-link_time">{{$t('mc.mimk.mcReport.linkText.time')}}:
        <span class="report__bold-text">
          {{mcReportElement.date.start}} {{mcReportElement.date.hour}}
        </span>
      </span>
    </div>
    <div class="report-checkboxes">
      <div
        class="checkbox-wrapper"
        v-for="(checkbox, i) in mcReportFields.boolean"
        :key="`boolean${i}`">
        <label class="checkbox report-checkbox">
          <input
            type="checkbox"
            class="checkbox-input"
            @input="eventOnCheckbox(i)"
            v-model="checkbox.answer"
            id="finished">
          <span class="checkbox-text">
            <inline-svg
              class="checkbox__icon"
              :src="require(`@/assets/svg/checkbox.svg`)"
            />
          </span>
          {{checkbox.question}}
        </label>
      </div>
    </div>
    <div class="flex">
      <div class="report-fields">
        <div class="report__input" v-for="(input, i) in mcReportFields.string" :key="`string${i}`">
          <label class="report__input-label">
            {{input.question}}
          </label>
          <input
            ref="link"
            class="input-text report__input-text"
            type="text"
            @input="eventOnInput(i)"
            :placeholder="`${(input.question).toLowerCase()}`"
            v-model="input.answer">
        </div>
        <div class="report__input" v-for="(input, i) in mcReportFields.datetime" :key="`datetime${i}`">
          <label class="report__input-label">
            {{input.question}}
          </label>
          <input
              ref="link"
              class="input-text report__input-text"
              type="datetime-local"
              @change="eventOnInput(i)"
              v-model="input.answer">
        </div>
      </div>
      <div class="report-fields">
        <div class="report__selects">
          <div class="report__choise" v-for="(radio, i) in mcReportFields.choice" :key="`choice${i}`">
            <label class="report__input-label">
              {{radio.question}}
            </label>
            <v-select
              v-if='showSelect'
              class="report__select"
              ref="trackOption"
              :clearable="false"
              :searchable="false"
              @input="eventOnSelect('choice')"
              :options="radio.answer_variants"
              :get-option-label="(option) => getVariant(option)"
              v-model="radio.answer"
              :placeholder="$t('mc.mimk.mcReport.placeholder.donotChoise')"
            />
          </div>
          <!-- Старые поля backoffice_courses скрыты, заменены на каскадный выбор курсов ниже -->
          <div class="report__choise" v-for="(radio, i) in mcReportFields.many_choice" :key="`many_choice${i}`">
            <label class="report__input-label">
              {{radio.question}}
            </label>
            <v-select
                v-if='showSelect'
                class="report__select"
                ref="trackOption"
                :clearable="false"
                :searchable="false"
                @input="eventOnSelect('many_choice')"
                multiple
                :options="radio.answer_variants"
                :get-option-label="(option) => getVariant(option)"
                v-model="radio.answer"
                :placeholder="$t('mc.mimk.mcReport.placeholder.donotChoise')"
            />
          </div>
          <!-- Каскадный выбор курсов (заменяет backoffice_courses) -->
          <div class="report__choise" v-if="showCourseSelector && mcReportFields.backoffice_courses && mcReportFields.backoffice_courses.length > 0">
            <div v-for="(courseField, i) in mcReportFields.backoffice_courses" :key="`backoffice_courses${i}`">
              <label class="report__input-label">
                {{ courseField.question }}
              </label>
              <CascadeCourseSelect
                :business-branch-id="businessBranchId"
                v-model="courseField.answer"
                @update:modelValue="(courses) => handleCoursesChange(courses, i)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import segmentIdToNameSegment from "@/helpers/segmentIdToNameSegment"
import CascadeCourseSelect from "@/components/UI/CascadeCourseSelect.vue"
import apiBooking from '@/api/master-classes/booking'

export default {
  components: {
    CascadeCourseSelect
  },
  data() {
    return {
      segmentIdToNameSegment,
      businessBranchId: null
    }
  },
  mounted() {
    this.getBusinessBranchId();
  },
  computed: {
    showCourseSelector() {
      return this.businessBranchId !== null;
    }
  },
  props: {
    mcReportElement: {
      type: Object
    },
    mcReportFields: {
      type: Object
    },
    showSelect: {
      type: Boolean
    }
  },
  methods: {
    eventOnSelect(type) {
      this.$emit('eventOnSelect', type)
    },
    eventOnInput() {
      this.$emit('eventOnInput')
    },
    eventOnCheckbox(index) {
      this.$emit('eventOnInput', index)
    },
    getVariants(variants) {
      const finalVariants = []

      variants.forEach((variant) => {
        const element = this.createElementFromHTML(variant)
        if (element.tagName === 'A') {
          finalVariants.push(element.textContent)
        } else {
          finalVariants.push(variant)
        }
      })

      return finalVariants
    },
    getVariant(variant) {
      const element = this.createElementFromHTML(variant)
      if (element.tagName === 'A') return element.textContent

      return variant
    },
    createElementFromHTML(htmlString) {
      const div = document.createElement('div');
      div.innerHTML = htmlString.trim();

      // Change this to div.childNodes to support multiple top-level nodes.
      return div.firstChild;
    },

    async getBusinessBranchId() {
      try {
        const response = await apiBooking.getSegmentInfo(segmentIdToNameSegment(this.mcReportElement.extraInformation.segment));
        this.businessBranchId = response.business_branch;
        console.log('Получен business_branch:', this.businessBranchId);
      } catch (error) {
        console.error('Ошибка при получении business_branch:', error);
      }
    },

    handleCoursesChange(courses, index) {
      this.mcReportFields.backoffice_courses[index].answer = courses;
      this.$emit('eventOnSelect', 'backoffice_courses');
    }
  },
}
</script>

<style lang="scss" scoped>

.report {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  &-fields{
    &:first-child {
      width: 65%;
    }
    &:last-child {
      width: 35%;
    }
  }
  &-checkboxes {
    display: inline-grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 10px;
  }
  &__bold-text {
    font-weight: 700;
  }
  &__radio-block {
    margin-top: 8px;
  }
  &__choise {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
  }
  &__radio {
    &:first-child {
      margin-right: 30px;
    }
  }
  &-checkbox {
    margin: 20px auto;
  }
  &-button{
    min-width: 200px;
    max-width: 200px;
    position: relative;
    &__tooltip {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  &__radio-block {
    margin-bottom: 20px;
  }

  &__input {
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
  }
  &__input-text {
    margin-top: 8px;
  }
  &__select {
    border: 1px solid transparent;
    margin-top: 8px;
    margin-bottom: 25px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &-fields {
    width: 100%;
    &:first-child {
      margin-right: 60px;
    }
  }
  &__btn_cancel {
    background: #F1F1F5;
    max-width: 130px;
    min-width: 130px;
    margin-right: 20px;
  }
}
.custom-autocomplete {
  position: relative;
  margin-top: 8px;
}

.autocomplete-input {
  position: relative;
  display: flex;
  align-items: center;

  input {
    width: 100%;
    padding-right: 35px;
  }
}

.autocomplete-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;

  img {
    width: 15px;
    height: 15px;
  }
}

.autocomplete-dropdown {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
}

.autocomplete-item {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
